import { useResizeObserver } from '#hooks/UNSAFE_useResizeObserver';
import { useCallback, useRef, useState } from 'preact/hooks';

const useDetectTruncation = () => {
  const rootRef = useRef<HTMLElement>(null);
  const [isTextTruncated, setIsTextTruncated] = useState<boolean>(false);

  const detectTruncation = useCallback(() => {
    if (rootRef.current) {
      setIsTextTruncated(rootRef.current.scrollWidth > rootRef.current.offsetWidth);
    }
  }, []);
  useResizeObserver(rootRef, detectTruncation);

  const detectTruncationProps = {
    ref: rootRef
  };

  return { detectTruncationProps, isTextTruncated };
};

export { useDetectTruncation };
